export const meverHero = {
  titleEn: 'MeVER',
  subtitleEn: 'Work & Lifestyle Products',
  descriptionJa: '仕事と暮らしの境界をなめらかにする、ワーク＆ライフスタイルプロダクト。',
  descriptionEn: 'Products that blur the line between work and life, designed for those who create.',
};

export const meverProducts = [
  {
    id: 'mever-chair-pro',
    nameEn: 'MeVER Chair Pro v1.1',
    nameJa: 'MeVER Chair Pro v1.1',
    category: 'Seating',
    descriptionJa:
      '人間工学に基づいた設計で、長時間の作業でも快適さを維持するフラッグシップモデル。4Dヘッドレスト、6Dアームレスト、フルアジャスタブル設計を搭載。',
    descriptionEn:
      'Flagship model with ergonomic design that maintains comfort during long work sessions. Features 4D headrest, 6D armrest, and fully adjustable design.',
    price: '¥123,200',
    features: [
      '4Dヘッドレスト',
      '6Dアームレスト',
      'フルアジャスタブル設計',
      '耐荷重150kg',
      'リクライニング135°',
      '5年間保証',
    ],
    image: 'https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/18555a65f21397adfed78720e8be08d7.png?format=webp&quality=80',
  },
  {
    id: 'mever-chair-core',
    nameEn: 'MeVER Chair Core v1.0',
    nameJa: 'MeVER Chair Core v1.0',
    category: 'Seating',
    descriptionJa:
      '必要十分の人間工学設計を備えたスタンダードモデル。ミニマルデザインで空間に調和し、4Dヘッドレストは別売りオプションとして追加可能。',
    descriptionEn:
      'Standard model with essential ergonomic design. Minimal design that harmonizes with any space, with optional 4D headrest available separately.',
    price: '¥79,200',
    features: [
      '必要十分の人間工学設計',
      'ミニマルデザイン',
      '4Dヘッドレスト(別売りオプション)',
      '空間と調和するデザイン',
    ],
    image: 'https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/f4a7d90296f789d46c6753357c7a51a3.png?format=webp&quality=80',
  },
  {
    id: 'mever-chair-style',
    nameEn: 'MeVER Chair Style v1.0',
    nameJa: 'MeVER Chair Style v1.0',
    category: 'Seating',
    descriptionJa:
      'バランスボールと似た効果の前傾姿勢機能を搭載したミニマルモデル。空間と調和する洗練されたデザインで、アクティブな作業姿勢をサポート。',
    descriptionEn:
      'Minimal model with forward tilt function similar to balance ball effect. Refined design that harmonizes with space and supports active working posture.',
    price: '¥69,300',
    features: [
      'バランスボールと似た効果の前傾姿勢機能',
      '空間と調和するデザイン',
      'アクティブな作業姿勢をサポート',
    ],
    image: 'https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/0e5886a34ba8b9935f350bf408063f8e.png?format=webp&quality=80',
  },
  {
    id: 'mever-desk-core',
    nameEn: 'MeVER Desk Core',
    nameJa: 'MeVER Desk Core',
    category: 'Desk',
    descriptionJa:
      '電動昇降式デスク。昇降速度40m/s、最低62cm〜最高125cmのワイドレンジ昇降幅。日本の職人による製作天板と抗菌メラミン天板を採用。',
    descriptionEn:
      'Electric standing desk with 40m/s lifting speed and wide range from 62cm to 125cm. Features Japanese craftsman-made top with antibacterial melamine surface.',
    price: '¥89,000',
    features: [
      '電動昇降式 昇降速度40m/s',
      '最低62cm〜最高125cmのワイドレンジ昇降幅',
      '日本の職人による製作天板',
      '抗菌メラミン天板',
      'デュアルモーター',
    ],
    image: 'https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/3a32f9477fa709e658131fa268c645e3.png?format=webp&quality=80',
  },
  {
    id: 'atelier-folio',
    nameEn: 'Atelier Folio for iPad',
    nameJa: 'Atelier Folio for iPad',
    category: 'Accessories',
    descriptionJa:
      'iPadを、あなたのアトリエに。クリエイティブワークに特化した、革新的なiPadスタンド&フォリオケース。無段階角度調整、Apple Pencilホルダー、プレミアムレザーを採用。',
    descriptionEn:
      'Turn your iPad into your atelier. Innovative iPad stand & folio case specialized for creative work. Features stepless angle adjustment, Apple Pencil holder, and premium leather.',
    price: '2026年3月 Makuake公開予定',
    features: [
      '無段階角度調整',
      'Apple Pencilホルダー',
      'プレミアムレザー',
      'iPad Pro/Air対応',
      'クリエイティブワーク特化設計',
    ],
    image: 'https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/432bdd1009cdd155013d836f9a744018.jpeg?format=webp&quality=80',
  },
  {
    id: 'craft-tea',
    nameEn: 'TEA Subscription',
    nameJa: 'TEA サブスクリプション',
    category: 'Tea',
    descriptionJa:
      'Craft Tea厳選のシングルオリジン日本茶・和紅茶のサブスクリプション。静岡・鹿児島の茶園から届く、クリエイターのための一杯。緑茶・ほうじ茶・和紅茶・烏龍茶・フレーバーティーをお届け。',
    descriptionEn:
      'Subscription service featuring carefully selected single-origin Japanese tea and black tea by Craft Tea. Premium tea from Shizuoka and Kagoshima tea gardens for creators.',
    price: '¥1,620〜/月',
    features: [
      'シングルオリジン',
      '毎月届く定期便',
      '緑茶・ほうじ茶・和紅茶・烏龍茶・フレーバー',
      '静岡・鹿児島産',
      'ティーバッグ形式',
    ],
    image: 'https://cdn.shopify.com/s/files/1/0554/2487/6735/files/4fcf3d99d33a254ebae5cfef432a8b4e_750x960_crop_center.jpg?v=1678774096',
  },
];

export const meverCategories = [
  { id: 'all', label: 'All', labelJa: 'すべて' },
  { id: 'Seating', label: 'Seating', labelJa: 'チェア' },
  { id: 'Desk', label: 'Desk', labelJa: 'デスク' },
  { id: 'Accessories', label: 'Accessories', labelJa: 'アクセサリー' },
  { id: 'Tea', label: 'Tea', labelJa: 'ティー' },
];

export const meverBrandStory = {
  titleJa: 'つくる人のための道具',
  titleEn: 'Tools for Those Who Create',
  bodyJa:
    'MeVERは、仕事と暮らしの間にある「つくる時間」を大切にする人のためのブランドです。素材の選定から仕上げまで、使い手の日常に寄り添うプロダクトを追求しています。',
  bodyEn:
    "MeVER is a brand for those who value the creative time between work and life. From material selection to finishing, we pursue products that accompany the user's daily routine.",
};
